import React, { ChangeEvent, useState } from 'react';
import {
    Box,
    TextField,
    InputAdornment,
    SvgIcon,
    IconButton,
    Tooltip,
} from '@material-ui/core';
import { Search } from 'react-feather';
import { MoreVert } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import { ConversationAdvancedFilters } from './ConversationAdvancedFilters';
import {
    hasActiveAdvancedFilters,
    type TConversationAdvancedFilters,
} from '../../constants/conversationAdvancedFilters';

interface SearchBarProps {
    value: string;
    onChange: (value: string) => void;
    onSearch: () => void;
    advancedFilters: TConversationAdvancedFilters;
    onAdvancedFiltersChange: (filters: TConversationAdvancedFilters) => void;
}

export const SearchBar = ({
    value,
    onChange,
    onSearch,
    advancedFilters,
    onAdvancedFiltersChange,
}: SearchBarProps) => {
    const { t } = useTranslation();
    const [openAdvancedFilters, setOpenAdvancedFilters] = useState(false);
    const hasAdvancedFilters = hasActiveAdvancedFilters({
        ...advancedFilters,
        tags: [],
    });

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        onChange(event.target.value);
    };

    return (
        <Box style={{ padding: 10 }}>
            <TextField
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SvgIcon fontSize="small" color="action">
                                <Search />
                            </SvgIcon>
                        </InputAdornment>
                    ),
                    endAdornment: (
                        <InputAdornment position="end">
                            <Tooltip title={t('Buttons.AdvancedSearch')}>
                                <IconButton
                                    onClick={() => setOpenAdvancedFilters(true)}
                                    aria-label={t('Buttons.AdvancedSearch')}
                                >
                                    <SvgIcon
                                        fontSize="small"
                                        color={
                                            hasAdvancedFilters
                                                ? 'primary'
                                                : 'action'
                                        }
                                    >
                                        <MoreVert />
                                    </SvgIcon>
                                </IconButton>
                            </Tooltip>
                        </InputAdornment>
                    ),
                    style: {
                        borderRadius: 50,
                    },
                }}
                placeholder={t('Chat.SearchConversations')}
                variant="outlined"
                fullWidth
                value={value}
                onChange={handleChange}
                onKeyDown={(event) => {
                    if (event.key === 'Enter') onSearch();
                }}
            />

            <ConversationAdvancedFilters
                open={openAdvancedFilters}
                setOpen={setOpenAdvancedFilters}
                values={advancedFilters}
                onApply={onAdvancedFiltersChange}
            />
        </Box>
    );
};
